import { apiClient } from '@/services/core/apiClient';
import type { ApiResponse } from '@/services/core/apiClient';

// User-related types based on existing API
export interface UserProfile {
  id: number;
  email: string;
  fullName: string;
  type: string;
  [key: string]: any; // For additional profile fields
}

export interface ProfileResponse {
  profile: UserProfile;
}

export interface HasuraTokenResponse {
  token: string;
  [key: string]: any;
}

// Users API service - TypeScript version of existing userApi.js
export const usersApi = {
  /**
   * Get user profile by email
   * Based on: USER_ENDPOINTS.PROFILE = '/api/user/:email/profile'
   * Matches original ApiClient.getProfile behavior
   */
  async getProfile(email: string, token?: string): Promise<any> {
    const response = await apiClient.get<any>(`/api/user/${email}/profile`, token);

    if (response.success) {
      console.log('User profile fetched:', response.data);
      // Return the raw data to match original behavior
      return response.data;
    } else {
      console.error('Failed to get user profile:', response.error);
      throw new Error(response.error || 'Failed to get user profile');
    }
  },

  /**
   * Get user profile by ID
   * Based on: USER_ENDPOINTS.PROFILE_BY_ID = '/api/user/:userId/profile'
   */
  async getProfileById(userId: string, token?: string): Promise<any> {
    const response = await apiClient.get<any>(`/api/user/${userId}/profile`, token);

    if (response.success) {
      console.log('User profile fetched by ID:', response.data);
      return response.data;
    } else {
      console.error('Failed to get user profile by ID:', response.error);
      throw new Error(response.error || 'Failed to get user profile by ID');
    }
  },

  /**
   * Get Hasura token for user
   * Based on: USER_ENDPOINTS.HASURA_TOKEN = '/api/user/:userId/hasuraToken'
   * Matches original ApiClient.getHasuraToken behavior
   */
  async getHasuraToken(userId: string | number, token?: string): Promise<any> {
    const response = await apiClient.get<any>(`/api/user/${userId}/hasuraToken`, token);

    if (response.success && response.data) {
      console.log('Hasura token fetched and stored successfully');
      // Return the raw data to match original behavior
      return response.data;
    } else {
      console.error('Failed to get Hasura token:', response.error);
      throw new Error(response.error || 'Failed to get Hasura token');
    }
  }
};

export default usersApi;